<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.category"
        placeholder="账户类别"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in ACCOUNT_CATEGORY.filter(item =>
            ['vcoin', 'bonus', 'redpacket', 'balance'].includes(item.key)
          )"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in FINANCE_WITHDRAWAL_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="apply"
        startPlaceholder="申请开始时间"
        endPlaceholder="申请截止时间"
      />
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="pay"
        startPlaceholder="打款开始时间"
        endPlaceholder="打款截止时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        style="margin-left: 10px"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-download"
        @click="handleExport"
        style="margin-left: 10px"
        >导出</el-button
      >
    </div>

    <div style="margin-bottom: 5px">提现数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column
        label="用户姓名"
        align="center"
        prop="userName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="用户手机号码"
        align="center"
        prop="userMobile"
        width="100"
      ></el-table-column>
      <el-table-column
        label="银行卡开户姓名"
        align="center"
        prop="bankUsername"
        width="140"
      ></el-table-column>
      <el-table-column
        label="银行名称"
        align="center"
        prop="bankName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="银行卡预留电话"
        align="center"
        prop="bankPhone"
        width="120"
      ></el-table-column>
      <el-table-column label="银行卡号" align="left" prop="bankNo" width="160"></el-table-column>
      <el-table-column label="账户类别" align="center" prop="category">
        <template slot-scope="scope">
          {{ getValue(ACCOUNT_CATEGORY, scope.row.category) }}
        </template>
      </el-table-column>
      <el-table-column label="账户类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ getValue(ACCOUNT_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0">{{
            getValue(FINANCE_WITHDRAWAL_STATUS, scope.row.status)
          }}</el-tag>
          <el-tag type="danger" v-if="scope.row.status === 2">{{
            getValue(FINANCE_WITHDRAWAL_STATUS, scope.row.status)
          }}</el-tag>
          <el-tag type="success" v-if="scope.row.status === 1">{{
            getValue(FINANCE_WITHDRAWAL_STATUS, scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="提现金额" align="center" prop="amount"></el-table-column>
      <el-table-column label="提现手续费费率(%)" align="center" prop="rate" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.rate * 100 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="打款金额" align="center" prop="payAmount"></el-table-column>
      <el-table-column align="center" prop="ctdate" label="打款时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" v-if="scope.row.payTime" />
          <span>{{ formatApiDate(scope.row.payTime) }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--        label="打款凭证"-->
      <!--        align="center"-->
      <!--        prop="payProof"-->
      <!--        width="200"-->
      <!--      >-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-image-->
      <!--            v-if="scope.row.payProof"-->
      <!--            style="width: 100px; height: 100px"-->
      <!--            :src="scope.row.payProof"-->
      <!--            fit="cover"-->
      <!--          ></el-image>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column align="center" prop="ctdate" label="申请时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="100"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="checkExamineVisible(true, scope.row)"
            class="comm_but_warp"
            v-if="scope.row.status === 0"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--    审核-->
    <el-dialog
      title="审核"
      :visible.sync="examineVisible"
      :close-on-click-modal="false"
      width="40%"
      @close="checkExamineVisible(false, {})"
    >
      <el-form
        ref="examineForm"
        :rules="examineRules"
        :model="examineForm"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="银行名称">
          <span>{{ examineObj.bankName }}</span>
        </el-form-item>
        <el-form-item label="银行卡开户姓名">
          <span>{{ examineObj.bankUsername }}</span>
        </el-form-item>
        <el-form-item label="银行卡号">
          <span>{{ examineObj.bankNo }}</span>
        </el-form-item>
        <el-form-item label="银行卡预留电话">
          <span>{{ examineObj.bankPhone }}</span>
        </el-form-item>
        <el-form-item label="提现金额">
          <span>{{ examineObj.amount }}</span>
        </el-form-item>
        <el-form-item label="打款金额">
          <span>{{ examineObj.payAmount }}</span>
        </el-form-item>
        <el-form-item label="提现结果" prop="status">
          <el-select
            v-model="examineForm.status"
            placeholder="提现结果"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in FINANCE_WITHDRAWAL_STATUS.filter(item => [1, 2].includes(item.key))"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="打款凭证截图 ">-->
        <!--          <UploadList-->
        <!--            :typeProps="UPLOAD_IMG_TYPE.COMMON"-->
        <!--            @valueFunc="getImgsValueFunc"-->
        <!--            paramsType="proof"-->
        <!--            :model="examineForm.proof"-->
        <!--            :maxCount="6"-->
        <!--          />-->
        <!--        </el-form-item>-->
        <el-form-item label="备注 ">
          <el-input type="textarea" :rows="4" placeholder="请输入" v-model="examineForm.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkExamineVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="examineOk">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getWithdrawalList, exportList, feedback } from "@/api/finance";
import { formatApiDate } from "@/utils/utils";
import { uploadXlsx } from "@/utils/index";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  FINANCE_WITHDRAWAL_STATUS,
  ACCOUNT_CATEGORY,
  ACCOUNT_TYPE,
  UPLOAD_IMG_TYPE
} from "@/utils/enumUtile";
import UploadList from "@/views/components/uploadList";
import DataPicker from "@/views/components/dataPicker";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    FINANCE_WITHDRAWAL_STATUS() {
      return FINANCE_WITHDRAWAL_STATUS;
    },
    ACCOUNT_CATEGORY() {
      return ACCOUNT_CATEGORY;
    },
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    }
  },
  components: { UploadList, DataPicker },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        category: null,
        status: null,
        applyStartTime: null, //申请开始时间
        applyEndTime: null, //申请截止时间
        payStartTime: null, //打款开始时间
        payEndTime: null //打款截止时间
      },
      examineVisible: false, // 审核的弹框
      examineObj: {}, // 审核的弹框
      examineRules: {
        status: [{ required: true, message: "提现结果不能为空", trigger: "change" }]
      },
      examineForm: {
        id: 0, //
        status: null,
        // proof: [], // 打款凭证
        remark: null // 备注
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getWithdrawalList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 审核 start
    checkExamineVisible(val, obj = {}) {
      this.examineObj = obj;
      if (obj && Object.keys(obj).length !== 0) {
        this.examineForm.id = obj.id;
      }
      if (!val) {
        this.examineForm.id = 0;
        this.examineForm.status = null;
        // this.examineForm.proof = null;
        this.examineForm.remark = null;
        this.$refs.examineForm.resetFields();
      }
      this.examineVisible = val;
    },
    examineOk() {
      this.$refs["examineForm"].validate(valid => {
        if (valid) {
          const form = this.examineForm;
          const params = {
            ...form
          };
          // if (form.proof && form.proof.length !== 0) {
          //   const urlArr = form.proof.map(obj => obj["dbUrl"]);
          //   params.proof = urlArr.join(",");
          // }
          feedback(params).then(resp => {
            if (resp && resp.bizcode === 100) {
              this.getList();
              this.checkExamineVisible(false, {});
              this.$notify({
                title: "成功",
                message: "审核成功",
                type: "success",
                duration: 2000
              });
            }
          });
        }
      });
    },
    // 审核 end
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "proof") {
        this.examineForm.proof = value;
      }
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "apply") {
        this.listQuery.applyStartTime = value[0];
        this.listQuery.applyEndTime = value[1];
      }
      if (type === "pay") {
        this.listQuery.payStartTime = value[0];
        this.listQuery.payEndTime = value[1];
      }
    },
    /**
     * 导出
     */
    handleExport() {
      const form = this.listQuery;
      const params = {
        ...form
      };
      exportList(params).then(response => {
        uploadXlsx(response, "用户提现申请表");
      });
    }
  }
};
</script>
<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  margin-left: 10px;
}
.comm_but_warp {
  margin-bottom: 10px;
}
</style>
